(function(){
  const SWIPER_URL = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";

  function loadSwiper(cb){
    if(window.Swiper) return cb();
    if(document.querySelector('script[data-swiper-lib]')){
      document.querySelector('script[data-swiper-lib]').addEventListener('load', cb);
      return;
    }
    const s = document.createElement('script');
    s.src = SWIPER_URL;
    s.async = true;
    s.dataset.swiperLib = "true";
    s.onload = cb;
    document.head.appendChild(s);
  }

  function initSwipers(scope=document){
    const cards = scope.querySelectorAll('.product-card:not([data-swiper-init])');
    cards.forEach(card=>{
      const el = card.querySelector('.product-swiper');
      if(!el) return;
      const prev = el.querySelector('.swiper-button-prev');
      const next = el.querySelector('.swiper-button-next');

      const swiper = new Swiper(el, {
        slidesPerView: 1,
        loop: true,
        spaceBetween: 8,
        navigation: { nextEl: next, prevEl: prev },
        simulateTouch: true,
        grabCursor: true,
      });

      // === CLICK HANDLING FOR FULL CARD ===
      let isDragging = false;
      swiper.on('touchMove', () => { isDragging = true; });
      swiper.on('touchEnd', () => { setTimeout(() => isDragging = false, 100); });

      card.addEventListener('click', (e) => {
        // prevent redirect if clicking arrows or dragging
        if (
          e.target.closest('.swiper-button-next') ||
          e.target.closest('.swiper-button-prev') ||
          isDragging
        ) return;

        const url = card.dataset.url;
        if (url) window.location.href = url;
      });

      card.dataset.swiperInit = "true";
    });
  }

  loadSwiper(()=>{
    initSwipers();
    document.addEventListener('shopify:section:load', e=>initSwipers(e.target));
    document.querySelectorAll('product-recommendations').forEach(rec=>{
      new MutationObserver(()=>initSwipers(rec)).observe(rec, {childList:true, subtree:true});
    });
  });
})();
